var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask__beam",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask__beam)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#2C96FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    transform: "translate(8 0) rotate(314 18 18) scale(1.2)",
    fill: "#106EEC",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 -4) rotate(-4 18 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21c2 1 4 1 6 0",
    stroke: "white",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1.5,
    height: 2,
    rx: 1,
    stroke: "none",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 1.5,
    height: 2,
    rx: 1,
    stroke: "none",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailSvg);
export default __webpack_public_path__ + "static/media/failSvg.25be2697ef8f736aa968bd878080b141.svg";
export { ForwardRef as ReactComponent };